import SeveranceView from '../SeveranceView.vue'
import SeveranceList from '../Pages/SeveranceList.vue'
import SeveranceWizard from '../Pages/SeveranceWizard.vue'
import SeveranceDetail from '../Pages/SeveranceDetail.vue'

const routes = [
  {
    path: '/liquidaciones',
    component: SeveranceView,
    children: [
      { path: '', name: 'severance-list', component: SeveranceList },
      { path: 'calcular', name: 'severance-calculate', component: SeveranceWizard },
      { path: ':id', name: 'severance-detail', component: SeveranceDetail },
    ],
  },
]

export default routes
